import React from 'react';
import { Link } from 'react-router-dom';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center px-4">
          <div className="text-center max-w-md" data-testid="error-boundary">
            <h2 className="text-2xl font-black">Something didn't quite load</h2>
            <p className="text-sm text-gray-600 mt-2">
              We hit a snag rendering this page. Please try again — if it keeps happening, let us know.
            </p>
            <div className="mt-6 flex gap-2 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="bg-[#22c55e] hover:bg-[#16a34a] text-black font-bold text-xs tracking-wider px-4 py-2 rounded"
              >
                RELOAD
              </button>
              <Link
                to="/"
                onClick={this.reset}
                className="border-2 border-black text-black font-bold text-xs tracking-wider px-4 py-2 rounded hover:bg-black hover:text-white transition"
              >
                GO HOME
              </Link>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
